import { MediaModel,
         EntityDataType,
         MediaSourceType}               from '../../common/media.model';
import { isNullOrUndefined, isNullOrWhitespace }           from '../../common/functions';
import { WalletBarcodeType }            from '../../common/wallet-barcode-type.enum';
import { MediaTypeEnum } from 'src/app/common/media-type.enum';
import { TranslationService } from 'src/app/shared/translation.service';
import { VoucherDetailValidator } from './voucher-detail-validator';

export class MediaDetailValidator {

    private detailTabIndex = 0;

    private emailTabIndex = 1;

    private voucherTabIndex = 2;

    private dataTabIndex = 2;

    private smsTabIndex = 3;

    private webTabIndex = 4;

    private walletTabIndex = 5;

    private distributionTabIndex = 6;

    public errors = new Array<Array<string>>();

    private locTabStrings = ['admin.web.detail',
                             'admin.web.email',
                             'admin.web.data',
                             'admin.web.voucher',
                             'admin.web.sms',
                             'admin.web.web',
                             'admin.web.wallet',
                             'admin.web.distribution'];

    private get locTabStringActive(): Array<string> {
        if (this.model.entityDataType === EntityDataType.Voucher) {
            return this.locTabStrings.filter(t => t !== 'admin.web.data');
        }
        return this.locTabStrings.filter(t => t !== 'admin.web.voucher');
    }

    constructor(
        private model: MediaModel,
        private tran: TranslationService
    ) {
        this.errors[this.detailTabIndex] = [];
        this.errors[this.voucherTabIndex] = [];
        this.errors[this.dataTabIndex] = [];
        this.errors[this.emailTabIndex] = [];
        this.errors[this.smsTabIndex] = [];
        this.errors[this.webTabIndex] = [];
        this.errors[this.walletTabIndex] = [];
        this.errors[this.distributionTabIndex] = [];
    }

    public Validate(isNewItem = false) {
        let m = this.model;
        // tslint:disable:max-line-length

        // Detail
        if (isNullOrWhitespace(m.description)) { this.errors[this.detailTabIndex].push('admin.web.mediaName'); }
        if (isNullOrWhitespace(m.group)) { this.errors[this.detailTabIndex].push('admin.web.group'); }

        if (isNewItem) { return; }

        if (m.mediaType === MediaTypeEnum.NotSet) { this.errors[this.detailTabIndex].push('admin.web.type'); }
        if (m.mediaSourceType === MediaSourceType.TenantTemplates &&
           (m.tenantTemplateID === MediaTypeEnum.NotSet || isNullOrUndefined(m.tenantTemplateID))) { this.errors[this.detailTabIndex].push('admin.web.template'); }

        // Voucher
        if (m.entityDataType === EntityDataType.Voucher) {
            // const vd = new VoucherDetailValidator(m, this.tran);
            // vd.validate();
            // this.errors[this.voucherTabIndex] = vd.errors;
        // Data
        } else {
            // default data, nothing mandatory
        }

        // Email
        if (m.distributionChannelEmail.active) {
            if (isNullOrWhitespace(m.distributionChannelEmail.subject)) { this.errors[this.emailTabIndex].push('admin.web.subject'); }
        }

        // SMS
        if (m.distributionChannelSms.active) {
            if (isNullOrWhitespace(m.distributionChannelSms.smsText)) { this.errors[this.smsTabIndex].push('model.distributionChannelSms.smsText'); }
        }

        // Web
        // No validation here

        // Wallet
        const colorValidator = /^rgb\(\d{1,3},\s?\d{1,3},\s?\d{1,3}\)$/;

        // Wallet editing moved to digital cards, so no validation here
        /*
        if (m.useWallet && (m.entityDataType === EntityDataType.Voucher || m.entityDataType === EntityDataType.User)) {
            if (m.walletBarcodeType === WalletBarcodeType.Undefined) { this.errors[this.walletTabIndex].push('admin.web.barcode-type'); }
            if (isNullOrWhitespace(m.walletTextColor)) { this.errors[this.walletTabIndex].push('admin.web.text-color');
            } else if (!colorValidator.test(m.walletTextColor)) {
                this.errors[this.walletTabIndex].push('admin.web.text-color');
            }
            if (isNullOrWhitespace(m.walletBackgroundColor)) { this.errors[this.walletTabIndex].push('admin.web.background-color');
            } else if (!colorValidator.test(m.walletBackgroundColor)) {
                this.errors[this.walletTabIndex].push('admin.web.background-color');
            }
            if (!isNullOrWhitespace(m.walletLabelColor) && !colorValidator.test(m.walletLabelColor)) {
                this.errors[this.walletTabIndex].push('admin.web.label-color');
            }
            if (isNullOrWhitespace(m.walletLogoText)) { this.errors[this.walletTabIndex].push('admin.web.logo-text'); }
            if (isNullOrWhitespace(m.walletTitle)) { this.errors[this.walletTabIndex].push('admin.web.title'); }
            if (isNullOrWhitespace(m.walletPrimaryDescription)) { this.errors[this.walletTabIndex].push('admin.web.text'); }
            if (isNullOrWhitespace(m.walletLogoUID)) { this.errors[this.walletTabIndex].push('admin.web.wallet-logo'); }
            if (isNullOrWhitespace(m.walletImageUID)) { this.errors[this.walletTabIndex].push('admin.web.wallet-image'); }
        }
        */

        // this.errors.forEach(e => {
        //     e.forEach(ie => {
        //         ie = reqFieldTran + ': ' + this.tran.transform(ie);
        //     });
        // });

        return this.errors.length === 0;
        // tslint:enable:max-line-length
    }

    public getSummaryMessage() {
        let result = '';
        let reqFieldTran = this.tran.instant('admin.web.required-field');
        this.errors.forEach((tab, index) => {
            if (tab.length > 0) {
                result += this.tran.instant(this.locTabStringActive[index]);
                result += ':<br/>';
                tab.forEach(e => {
                    result += (reqFieldTran + ': ' + this.tran.instant(e) + '<br/>');
                });
                result += '<br/><br/>';
            }
        });

        return result;
    }
}
